import React from 'react';
import { useParams } from 'react-router-dom';
import ChatEmbed from '../../components/UseCaseComponents/ChatEmbed';

const ChatAgentView = () => {
  const { agentId } = useParams();

  return (
    <div className="px-4 py-6 sm:px-6 sm:py-8 lg:px-10 lg:py-10">
      <ChatEmbed
        agentId={agentId}
        className="mx-auto h-[clamp(500px,80dvh,900px)] min-h-[400px] w-full max-w-[720px]"
      />
    </div>
  );
};

export default ChatAgentView;